import { createBrowserRouter, Navigate } from "react-router-dom";
import { USER_ROLES } from "../constants/roles";
import ProtectedRoute from "../components/Router/ProtectedRoute";
import { lazy, Suspense } from "react";

import {
  FORGOT_PASSWORD_PATH,
  LOGIN_PATH,
  RESET_PASSWORD_PATH,
} from "./routes";
import { AdminRouter } from "./Admin/AdminRouter";
import { InstitutionRouter } from "./Institution/InstitutionRouter";
import FullScreenLoader from "../components/Loaders/FullScreenLoader";
import Unauthorized from "../views/Auth/Unauthorized";

const AdminLayout = lazy(() => import("../layouts/AdminLayout"));
const InstitutionLayout = lazy(() => import("../layouts/InstitutionLayout"));
const Login = lazy(() => import("../views/Auth/Login"));
const ForgotPassword = lazy(() => import("../views/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../views/Auth/ResetPassword"));
const GuestLayout = lazy(() => import("../layouts/GuestLayout"));
const ErrorPage = lazy(() => import("../views/ErrorPage"));
const Home = lazy(() => import("../views/Home"));

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<FullScreenLoader />}>
        <GuestLayout />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<FullScreenLoader />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: LOGIN_PATH,
        element: (
          <Suspense fallback={<FullScreenLoader />}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: FORGOT_PASSWORD_PATH,
        element: (
          <Suspense fallback={<FullScreenLoader />}>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: RESET_PASSWORD_PATH,
        element: (
          <Suspense fallback={<FullScreenLoader />}>
            <ResetPassword />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/admin",
    element: (
      <Suspense fallback={<FullScreenLoader />}>
        {/* <ProtectedRoute role={USER_ROLES.ADMIN} element={<AdminLayout />} /> */}
        <ProtectedRoute
          role={[USER_ROLES.ADMIN, USER_ROLES.OTHER_ADMINISTRATOR]}
          element={<AdminLayout />}
        />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
    children: AdminRouter,
  },

  {
    path: "/institution",
    element: (
      <Suspense fallback={<FullScreenLoader />}>
        {/* <ProtectedRoute
          role={USER_ROLES.INSTITUTION_ADMIN}
          element={<InstitutionLayout />}
        /> */}
        <ProtectedRoute
          role={[USER_ROLES.INSTITUTION_ADMIN]}
          element={<InstitutionLayout />}
        />
      </Suspense>
    ),

    errorElement: <ErrorPage />,
    children: InstitutionRouter,
  },

  {
    path: "/unauthorized",
    element: (
      <Suspense fallback={<FullScreenLoader />}>
        <Unauthorized />
      </Suspense>
    ),
  },
]);

export default router;
